module.exports = __webpack_public_path__ + "static/media/searchIcon.c2bb6160.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/searchIcon.svg
// module id = 139
// module chunks = 0